// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1gcpx","itemTitle":"ClientEmergencyInfo_itemTitle__3CDDF","itemText":"ClientEmergencyInfo_itemText__q4dYS"};